module.exports = __webpack_public_path__ + "img/sx-adv.6d72b668.png";